import React from 'react'

import { Chip, Tooltip } from '@mui/material'
import { planGroup } from 'features/customers/constants/planGroups'
import { planLabel } from 'features/customers/constants/planLabels'

type PlanBadgeProps = {
  name?: string
}

const PlanBadge = ({ name }: PlanBadgeProps) => {
  if (!name) return <>—</>

  const { label: group, bg, text, border } = planGroup(name)

  return (
    <Tooltip title={`${name} · ${group}`}>
      <Chip
        aria-label={`${planLabel(name)}, ${group} plan`}
        // A span, not Chip's default div, which would be invalid inside the sub-account list's <p>.
        component="span"
        label={planLabel(name)}
        size="small"
        sx={{
          bgcolor: bg,
          color: text,
          border: `1px solid ${border}`,
          fontWeight: 700,
          letterSpacing: '0.03em',
        }}
      />
    </Tooltip>
  )
}

export default PlanBadge
